import { render, staticRenderFns } from "./PhoneActionButton.vue?vue&type=template&id=a27ebad2&scoped=true&lang=pug"
import script from "./PhoneActionButton.vue?vue&type=script&lang=js"
export * from "./PhoneActionButton.vue?vue&type=script&lang=js"
import style0 from "./PhoneActionButton.vue?vue&type=style&index=0&id=a27ebad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ebad2",
  null
  
)

export default component.exports